
let GROUPS = [
  {
    name: "Sieć energetyczna",
    prefix: "prad",
    items: [
      {
        name: "Sieć na terenie (T/N)",
        field: "prad"
      },
      {
        name: "Rodzaj",
        field: "prad_rodzaj"
      },
      {
        name: "Typ",
        field: "prad_typ"
      },
      {
        name: "Napięcie [kV]",
        field: "prad_napiecie"
      },
      {
        name: "Dostępna maksymalna moc [MW]",
        field: "prad_maks_moc"
      },
      {
        name: "Odległość sieci od terenu [m]",
        field: "prad_odl_przylacza_od_granicy"
      },
      {
        name: "Możliwość przyłączenia do sieci",
        field: "prad_mozna_przylaczyc_enum",
        type: "mozna_przylaczyc_enum"
      },
      {
        name: "Odległość przyłącza od granicy terenu [m]",
        field: "prad_odl_od_terenu"
      },
      {
        name: "Czas oczekiwania na przyłączenie (mies.)",
        field: "prad_czas_do_przylaczenia"
      },
      {
        name: "Lokalizacja Głównego Punktu Zasilania",
        field: "prad_lokalizacja_gpz"
      },
      {
        name: "Odległość od GPZ [m]",
        field: "prad_odleglosc_gpz"
      },
      {
        name: "Gestor infrastruktury",
        field: "prad_gestor"
      },
      {
        name: "Rozbudowa infrastruktury",
        field: "prad_rozbudowa"
      }
    ]
  },
  {
    name: "Sieć gazowa",
    prefix: "gaz",
    items: [
      {
        name: "Sieć na terenie (T/N)",
        field: "gaz"
      },
      {
        name: "Rodzaj",
        field: "gaz_rodzaj"
      },
      {
        name: "Średnica [fi/mm]",
        field: "gaz_srednica"
      },
      {
        name: "Wydajność [m3/h]",
        field: "gaz_wydajnosc"
      },
      {
        name: "Wartość opałowa [MJ/m3]",
        field: "gaz_wartosc_opalowa"
      },
      {
        name: "Odległość sieci od terenu [m]",
        field: "gaz_odl_od_terenu"
      },
      {
        name: "Możliwość przyłączenia do sieci",
        field: "gaz_mozna_przylaczyc_enum",
        type: "mozna_przylaczyc_enum"
      },
      {
        name: "Odległość przyłącza od granicy terenu [m]",
        field: "gaz_odl_przylacza_od_granicy"
      },
      {
        name: "Czas oczekiwania na przyłączenie (mies.)",
        field: "gaz_czas_do_przylaczenia"
      },
      {
        name: "Gestor infrastruktury",
        field: "gaz_gestor"
      },
      {
        name: "Rozbudowa infrastruktury",
        field: "gaz_rozbudowa"
      }
    ]
  },
  {
    name: "Sieć wodociągowa",
    prefix: "woda",
    items: [
      {
        name: "Sieć na terenie (T/N)",
        field: "woda"
      },
      {
        name: "Średnica [fi/mm]",
        field: "woda_srednica"
      },
      {
        name: "Wydajność [m3/h]",
        field: "woda_wydajnosc"
      },
      {
        name: "Odległość sieci od terenu [m]",
        field: "woda_odl_od_terenu"
      },
      {
        name: "Możliwość przyłączenia do sieci",
        field: "woda_mozna_przylaczyc_enum",
        type: "mozna_przylaczyc_enum"
      },
      {
        name: "Odległość przyłącza od granicy terenu [m]",
        field: "woda_odl_przylacza_od_granicy"
      },
      {
        name: "Czas oczekiwania na przyłączenie (mies)",
        field: "woda_czas_do_przylaczenia"
      },
      {
        name: "Gestor infrastruktury",
        field: "woda_gestor"
      },
      {
        name: "Rozbudowa infrastruktury",
        field: "woda_rozbudowa"
      }
    ]
  },
  {
    name: "Sieć kanalizacyjna",
    prefix: "kanal",
    items: [
      {
        name: "Sieć na terenie (T/N)",
        field: "kanal"
      },
      {
        name: "Średnica [fi/mm]",
        field: "kanal_srednica"
      },
      {
        name: "Wydajność [m3/h]",
        field: "kanal_wydajnosc"
      },
      {
        name: "Odległość sieci od terenu [m]",
        field: "kanal_odl_od_terenu"
      },
      {
        name: "Możliwość przyłączenia do sieci",
        field: "kanal_mozna_przylaczyc_enum",
        type: "mozna_przylaczyc_enum"
      },
      {
        name: "Odległość przyłącza od granicy terenu [m]",
        field: "kanal_odl_przylacza_od_granicy"
      },
      {
        name: "Czas oczekiwania na przyłączenie (mies)",
        field: "kanal_czas_do_przylaczenia"
      },
      {
        name: "Gestor infrastruktury",
        field: "kanal_gestor"
      },
      {
        name: "Rozbudowa infrastruktury",
        field: "kanal_rozbudowa"
      }
    ]
  },
  {
    name: "Sieć deszczowa",
    prefix: "deszcz",
    items: [
      {
        name: "Sieć na terenie (T/N)",
        field: "deszcz"
      },
      {
        name: "Średnica [fi/mm]",
        field: "deszcz_srednica"
      },
      {
        name: "Odległość sieci od terenu [m]",
        field: "deszcz_odl_od_terenu"
      },
      {
        name: "Możliwość przyłączenia do sieci",
        field: "deszcz_mozna_przylaczyc_enum",
        type: "mozna_przylaczyc_enum"
      },
      {
        name: "Odległość przyłącza od granicy terenu [m]",
        field: "deszcz_odl_przylacza_od_granicy"
      },
      {
        name: "Rozbudowa infrastruktury",
        field: "deszcz_rozbudowa"
      }
    ]
  },
  {
    name: "Sieć teletechniczna",
    prefix: "tele",
    items: [
      {
        name: "Sieć na terenie (T/N)",
        field: "tele"
      },
      {
        name: "Rodzaj",
        field: "tele_rodzaj"
      },
      {
        name: "Odległość sieci od terenu [m]",
        field: "tele_odl_od_terenu"
      },
      {
        name: "Możliwość przyłączenia do sieci",
        field: "tele_mozna_przylaczyc_enum",
        type: "mozna_przylaczyc_enum"
      },
      {
        name: "Odległość przyłącza od granicy terenu [m]",
        field: "tele_odl_przylacza_od_granicy"
      },
      {
        name: "Liczba linii analogowych",
        field: "tele_l_analog"
      },
      {
        name: "Liczba linii ISDN",
        field: "tele_l_isdn"
      },
      {
        name: "Gestor infrastruktury",
        field: "tele_gestor"
      },
      {
        name: "Rozbudowa infrastruktury",
        field: "tele_rozbudowa"
      }
    ]
  }
];

GROUPS.forEach(group => {
  let start = group.prefix.length + 1;
  group.items.forEach(item => {
    item.trans = item.field.substr(start);
  })
})

export default GROUPS;